import { render, staticRenderFns } from "./OrdersToFulfill.vue?vue&type=template&id=5265c642"
import script from "./OrdersToFulfill.vue?vue&type=script&lang=js"
export * from "./OrdersToFulfill.vue?vue&type=script&lang=js"
import style0 from "./OrdersToFulfill.vue?vue&type=style&index=0&id=5265c642&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports